module.exports = __webpack_public_path__ + "assets/images/vcr_park-02.14d3ecd14b7814229d39c087cc99a569.svg";